<template>
    <aside id="sidebarContent" class="u-sidebar u-unfold--css-animation u-unfold--hidden" aria-labelledby="sidebarNavToggler" style="animation-duration: 500ms; right: 0px;">
        <div class="u-sidebar__scroller">
            <div class="u-sidebar__container">
                <div class="u-sidebar--account__footer-offset">
                    <!-- Toggle Button -->
                    <div class="d-flex justify-content-between align-items-center pt-4 px-7">
                        <h3 class="h6 mb-0">Mon compte</h3>

                        <button type="button" class="close ml-auto"
                                aria-controls="sidebarContent"
                                aria-haspopup="true"
                                aria-expanded="false"
                                data-unfold-event="click"
                                data-unfold-hide-on-scroll="false"
                                data-unfold-target="#sidebarContent"
                                data-unfold-type="css-animation"
                                data-unfold-animation-in="fadeInRight"
                                data-unfold-animation-out="fadeOutRight"
                                data-unfold-duration="500">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <!-- End Toggle Button -->

                    <!-- Content -->
                    <div class="js-scrollbar u-sidebar__body">
                        <!-- Holder Info -->
                        <header class="d-flex align-items-center u-sidebar--account__holder mt-3">
                            <div class="position-relative">
                                <img class="u-sidebar--account__holder-img" :src="avatarDisplayUrl" alt="Image Description">
                                <span class="badge badge-xs badge-outline-success badge-pos rounded-circle"></span>
                            </div>
                            <div class="ml-3">
                                <span class="font-weight-semi-bold">{{ user.info.username }}
<!--                                  <span class="badge badge-success ml-1">Pro</span>-->
                                </span>
                                <span class="u-sidebar--account__holder-text">{{ user.info.profile.profession }}</span>
                            </div>
                        </header>
                        <!-- End Holder Info -->

                        <div class="u-sidebar__content--account">
                            <!-- List Links -->
                            <ul class="list-unstyled u-sidebar--account__list">
                                <li class="u-sidebar--account__list-item">
                                    <router-link v-if="isDisplayProfileLink"
                                                 class="u-sidebar--account__list-link"
                                                 :to="{name: 'viewProfile', params: {username: user.info.username}}">
                                        Profil
                                    </router-link>
                                    <Logout/>
                                </li>
                            </ul>
                            <!-- End List Links -->
                        </div>
                    </div>
                </div>

                <!-- Footer -->
                <footer id="SVGwaveWithDots" class="u-sidebar__footer u-sidebar__footer--account">
                    <ul class="list-inline mb-0">
                        <li class="list-inline-item pr-3">
                            <a class="u-sidebar__footer--account__text" href="#">Politique de confidentialité</a>
                        </li>
                        <li class="list-inline-item pr-3">
                            <router-link class="u-sidebar__footer--account__text"
                                         :to="{'name': 'terms'}">Termes</router-link>
                        </li>
                        <li class="list-inline-item">
                            <a class="u-sidebar__footer--account__text" href="#">
                                <i class="fas fa-info-circle"></i>
                            </a>
                        </li>
                    </ul>

                    <!-- SVG Background Shape -->
                    <div class="position-absolute right-0 bottom-0 left-0">
                        <img src="../../public/assets/svg/components/wave-bottom-with-dots.svg" alt="Image Description"
                             data-parent="#SVGwaveWithDots">
                    </div>
                    <!-- End SVG Background Shape -->
                </footer>
                <!-- End Footer -->
            </div>
        </div>
    </aside>
</template>

<script>
    import {mapState} from "vuex";
    import Logout from "./Logout";
    import {ASSETS_FOLDER} from "../settings";

    export default {
        name: "AccountSidebarNav",
        components: {Logout},
        computed: {
            ...mapState([
                'user',
            ]),
            avatarUrl: function() {
                return this.$store.state.user.info.profile.avatarUrl;
            },
            avatarDisplayUrl: function () {
                return this.avatarUrl ? this.avatarUrl : `${ASSETS_FOLDER}/img/100x100/anonymous_user.png`
            },
            isDisplayProfileLink: function () {
                if(this.$route.name !== 'viewProfile'){
                    return true;
                }
                else return this.$route.params.username !== this.user.info.username;
            }
        }
    }
</script>

<style scoped>

</style>